/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';

import { BaSeIcon } from '@base/react';
import {
  AlignButtonDetail,
  ContainerImg,
  ContainerInfos,
  ContainetSection,
  LogoContainer,
} from './style';

import { FormContext } from '../../hook/form-context';
import ModalDetail from '../modal-detail/motal-detail';

const EmpretecCard = ({
  logoEmpretec,
  imgEmpretecLargeDisplay,
  imgEmpretecSmallDisplay,
  bgColor,
  textColor,
  bgColorInformations,
  description,
  moduleId,
  bgButtonColor,
  foregroundColor,
  moduleSelect,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { handleMenuClick } = React.useContext(FormContext);

  const openModal = React.useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = () => setIsOpen(false);

  const closeModalToSSubscription = async () => {
    setTimeout(() => {
      setIsOpen(false);
    }, 500);
    await handleMenuClick('7');
  };

  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <ContainetSection bgColor={bgColor}>
      {isOpen && (
        <ModalDetail
          closeModal={closeModal}
          empretecId={moduleId}
          closeModalToSSubscription={closeModalToSSubscription}
        />
      )}

      <ContainerInfos bgColor={bgColorInformations}>
        <LogoContainer>
          <img src={logoEmpretec} alt="Logo Empretec" />
        </LogoContainer>

        <p>{description}</p>

        <AlignButtonDetail>
          <button
            className="botao-detalhar"
            onClick={openModal}
            style={{
              width: '40px',
              height: '50px',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              border: 'none',
              cursor: 'pointer',
              backgroundColor: bgButtonColor,
            }}
          >
            <BaSeIcon
              color={foregroundColor}
              description="Sólido"
              name="angle-right"
              size={21}
            />
          </button>
        </AlignButtonDetail>
      </ContainerInfos>

      <ContainerImg>
        <img src={imgEmpretecSmallDisplay} alt="img-empre2ec" />
      </ContainerImg>
    </ContainetSection>
  );
};

export default EmpretecCard;
